export default "__VITE_ASSET__b7c41425__"